<template>
  <div class="created-text">
    <div class="d-flex align-items-center justify-content-end font-size-10">
      <div class="me-3">
        <p
          class="text-secondary mb-0"
          v-b-popover.hover.top="
            `Created : ${global_format_date_and_time(dataToBeShow.created_at)}`
          "
        >
          Created by
          <span class="mx-2">: -</span>
          <span>{{ dataToBeShow.created_by }}</span>
        </p>
      </div>
      <p
        class="text-secondary mb-0"
        v-b-popover.hover="
          `Updated : ${global_format_date_and_time(dataToBeShow.updated_at)}`
        "
      >
        Updated by
        <span class="mx-2">: -</span>
        <span>{{ dataToBeShow.updated_by }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Data-Update-Info",
  props: {
    dataToBeShow: { type: Object },
  },
};
</script>

<style scoped>
.created-text {
  position: fixed;
  bottom: 8px;
  right: 10px;
}
</style>
